import PendoInput from '../../../../components/input/pendo-input.vue.js';
import PendoNotification from '../../../../components/notification/pendo-notification.js';
import PendoButton from '../../../../components/button/pendo-button.vue.js';
import get from 'lodash/get.js';

var script = {
  name: 'NoteInput',
  components: {
    PendoInput,
    PendoButton
  },
  props: {
    displayAlert: {
      type: Object,
      required: true
    },
    noteAction: {
      type: Object,
      default: () => ({})
    },
    noteError: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      note: '',
      postingNote: false
    };
  },
  computed: {
    canCreateNote() {
      return get(this.displayAlert, 'canCreateNote');
    },
    noteTooLong() {
      return this.note.length > 500;
    },
    isCreatingNote() {
      return this.noteAction.create;
    }
  },
  watch: {
    isCreatingNote(newValue, oldValue) {
      if (this.postingNote && !newValue && oldValue) {
        if (this.noteError.create) {
          PendoNotification({
            type: 'error',
            title: 'Note was not posted.',
            message: 'Looks like something went wrong when posting your note. Please try again.',
            duration: 3000
          });
        } else {
          this.clear();
        }
        this.postingNote = false;
      }
    }
  },
  methods: {
    submitNote() {
      this.postingNote = true;
      this.$emit('create-note', {
        alert: this.displayAlert,
        text: this.note
      });
    },
    clear() {
      this.note = '';
      this.$refs.noteTextarea.resizeTextarea();
    }
  }
};

export { script as default };
//# sourceMappingURL=note-input.vue2.js.map
